export default __webpack_public_path__ + "static/media/Limitless-BNG_WordmarkLogo.4a5e919e.png";